import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";
import { Nest } from "../../events-screen/event-page-models/noal.models";
import { BrotherAttributionService } from "../../../_services/brother-attribution.service";

import { fromPromise } from "rxjs/observable/fromPromise";
import { FamilyMemberWithSiblingsModel } from "../brother-attribution-models/family-model";

import { ITranslations } from "../../../_models/ITranslations";
import { TranslationService } from "../../../_services/translation.service";

export interface ChildObjectForEdit {
  id: number;
  firstName: string;
  lastName: string;
  layer: string;
  nest: string;
  address: string;
  israeliId: string;
  status: "new" | "exiting" | "deleted";
}

@Component({
  selector: "brother-attribution-family-editor",
  templateUrl: "./brother-attribution-family-editor.component.html",
  styleUrls: [
    "brother-attribution-family-editor.component.scss",
    "../brother-attribution-child-selector/brother-attribution-child-selector.component.scss",
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
  ],
})
export class BrotherAttributionFamilyEditorComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public childrenInFamily: ChildObjectForEdit[] = [];

  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput")
  public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("updateFamilyStatus")
  public updateNewFamilyStatus: EventEmitter<ChildObjectForEdit[]> =
    new EventEmitter<ChildObjectForEdit[]>();

  constructor(
    private modalService: NgbModal,
    private brotherAttributionService: BrotherAttributionService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public set familyToEdit(value: ChildObjectForEdit[]) {
    if (this.childrenInFamily.length !== 0) {
      return;
    }
    this.childrenInFamily = value;
  }

  public ngOnInit(): void {
    this.brotherAttributionService.searchChildAndSiblingsByText("אבי").then();
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(this.addIsChosenPropertyToChildren(term));
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.autoCompleteInput.nativeElement.value = "";
    const newFamilySelected = $event.item as FamilyMemberWithSiblingsModel;
    const allChildren =
      BrotherAttributionService.serializeFamilyMemberWithSiblingsToFamilyModel(
        newFamilySelected
      );
    const allSelectedChildren = new Set(
      this.childrenInFamily.map((child) => child.id)
    );
    const newChildren = allChildren.members
      .map((child) => {
        if (allSelectedChildren.has(child.id)) {
          return null;
        }
        return {
          ...child,
          status: "new",
        };
      })
      .filter((c) => c);

    this.childrenInFamily.push(...(newChildren as ChildObjectForEdit[]));
    this.updateFamilyStatus();
  }

  public actionButton($event, childObejct: ChildObjectForEdit) {
    switch (childObejct.status) {
      case "new":
        this.childrenInFamily.splice(
          this.childrenInFamily.indexOf(childObejct),
          1
        );
        break;
      case "exiting":
        childObejct.status = "deleted";
        break;
      case "deleted":
        childObejct.status = "exiting";
        break;
    }

    this.updateFamilyStatus();
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  private async addIsChosenPropertyToChildren(
    term: string
  ): Promise<FamilyMemberWithSiblingsModel[]> {
    const familyMemberWithSiblingsModels: FamilyMemberWithSiblingsModel[] =
      (await this.brotherAttributionService.searchChildAndSiblingsByText(
        term
      )) || [];

    const allSelectedChildren = new Set(
      this.childrenInFamily.map((child) => child.id)
    );

    return familyMemberWithSiblingsModels.map((child) => {
      let status: "new" | "exiting" | "deleted" = "new";
      if (allSelectedChildren.has(child.id)) {
        status = "exiting";
        if (
          this.childrenInFamily.find((c) => c.id === child.id).status ===
          "deleted"
        ) {
          status = "deleted";
        }
      }

      return {
        ...child,
        status,
      };
    });
  }

  private updateFamilyStatus() {
    this.updateNewFamilyStatus.emit(this.childrenInFamily);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-family-editor/brother-attribution-family-editor.component.ts